/* Olyra fiche v3 : carrousels (flèches, points), filtres d'avis. Se ré-initialise sur shopify:section:load. */
(function () {
  function car(root) {
    root.querySelectorAll('[data-pv-car]').forEach(function (c) {
      var tr = c.querySelector('[data-pv-track]'), dots = c.querySelector('[data-pv-dots]');
      if (!tr) return;
      function items() { return Array.prototype.filter.call(tr.children, function (e) { return !e.hidden; }); }
      function step() { var it = items()[0]; return it ? it.getBoundingClientRect().width + 14 : tr.clientWidth; }
      var p = c.querySelector('[data-pv-prev]'), n = c.querySelector('[data-pv-next]');
      if (p) p.onclick = function () { tr.scrollBy({ left: -step(), behavior: 'smooth' }); };
      if (n) n.onclick = function () { tr.scrollBy({ left: step(), behavior: 'smooth' }); };
      function draw() {
        if (!dots) return; var its = items(), k = Math.round(tr.scrollLeft / step());
        if (dots.children.length !== its.length) { dots.innerHTML = ''; its.forEach(function () { dots.appendChild(document.createElement('span')); }); }
        Array.prototype.forEach.call(dots.children, function (d, i) { d.classList.toggle('is-on', i === Math.min(k, its.length - 1)); });
        dots.hidden = tr.scrollWidth <= tr.clientWidth + 2;
      }
      tr.addEventListener('scroll', function () { window.requestAnimationFrame(draw); }, { passive: true });
      window.addEventListener('resize', draw); draw();
      if (c.hasAttribute('data-pv-filter')) {
        c.querySelectorAll('.pv-filt button').forEach(function (b) {
          b.onclick = function () {
            c.querySelectorAll('.pv-filt button').forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-pressed', x === b); });
            Array.prototype.forEach.call(tr.children, function (e) { e.hidden = b.dataset.f === 'photo' && e.dataset.photo !== '1'; });
            tr.scrollLeft = 0; draw();
          };
        });
      }
    });
  }
  document.addEventListener('DOMContentLoaded', function () { car(document); });
  document.addEventListener('shopify:section:load', function (e) { car(e.target); });
})();
